/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-duplicate-imports */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, ChangeEvent, useCallback, useMemo } from 'react';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import {
  Box,
  Table,
  Button,
  Dialog,
  Divider,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  IconButton,
  Typography,
  DialogActions,
  DialogContent,
  FormHelperText,
  TableContainer,
  Checkbox,
  TextField,
  InputAdornment,
  Popover,
  Chip
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { loadXlsx } from '../../../../../../utils/loadXlsx';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import { API } from '../../../../../../api';
import InviteUserDialog from '../InviteUserDialog';
import ProgramUserDetails from './ProgramUserDetails';
import ProgramUserTableRow from './ProgramUserTableRow';
import ProgramInvitedUsers from './ProgramInvitedUsers';
import { ThreeDots } from 'react-loader-spinner';
import { adminPanel } from '../../../../../../utils/muiStyle';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useModule } from '../../../../../../utils/useModule';
import upload from '../../../../../../assets/images/upload.svg';
import { getUserDetails } from '../../../../../../utils/orgName';
import { useProgramCreation } from '../../../../../../components/admin3/newProgram/ProgramCreationContext';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import SearchIcon from '@mui/icons-material/Search';
import {
  IGroupUser,
  fetchGroupUsers,
  groupUsersActions
} from '../../../../../../redux/slices/group-users/groupUsersSlice';
import LevelQuestionAnswers from '../../Dialogs/LevelQuestionAnswers';
import bulkupload from '../../../../../../assets/images/bulkupload.svg';
import downloadblue from '../../../../../../assets/images/downloadblue.svg';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { grpDetailsActions } from '../../../../../../redux/slices/group-details/groupDetails';
import ConfirmDialog from '../../../../../../components/DialogUi/ConfirmDialog';
import { IAllTaskData } from '../../../../../../redux/slices/goals-tasks/getTasksSlice';
import CommonModalHeader from '../../../../../../components/DialogUi/CommonModalHeader';
import { fetchAllGroupsList } from '../../../../../../redux/slices/getAllGroupsListSlice';
import { getGoalProgressShowOrNot } from '../../../../components/common';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import DosenButton from '../../../../../../components/ui/Buttons/DosenButton';
import { buttonDisabledSx } from '../../../../../../components/ui/Buttons/buttonStyles';
import { setOrgMemberAttributes } from '../../../../../../redux/slices/user-profile/userProfieSlice';
import { getLLAuthHeaders } from '../../../../utils/llAuthHeaders';
import { useRoleLock } from '../../../capability-setup/create/roleLock';
import { useMemberWord } from '../../../../../../utils/memberTypeLabels';
import {
  buildGroupPutPayload,
  detectAttemptedGrpDeselectionFromProgramUi,
  filterHiddenMemberAttributes,
  hasAudienceTargeting,
  isMongoObjectIdString,
  mergeGrpSelection,
  parseGroupMemberAttributesResponse,
  participatingAudienceRules,
  unwrapEnvelope,
  type AudienceRule
} from '../../../../utils/memberAttributes';
import AudienceRulesEditor from '../learning-lifecycle/AudienceRulesEditor';
import { useOrgAudienceOptions } from '../learning-lifecycle/useOrgMemberAttributes';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Creation flow: who the stored audience matches, as a note beside the members
// search — the number Invite & Finish acts on.
const AudienceMatchNote = ({ count, loading }: { count: number; loading: boolean }) => (
  <Box
    role="status"
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      minWidth: 0,
      px: 1.25,
      py: 0.5,
      borderRadius: '6px',
      border: '1px solid rgba(247,148,32,0.4)',
      background: 'linear-gradient(180deg, rgba(247,148,32,0.1) 0%, rgba(241,90,38,0.1) 100%)'
    }}
  >
    <InfoOutlinedIcon sx={{ fontSize: 18, color: '#F79420', flexShrink: 0 }} />
    <Typography
      sx={{
        flexShrink: 0,
        color: '#F79420',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.08em',
        fontFamily: 'Inter, sans-serif'
      }}
    >
      NOTE
    </Typography>
    <Typography sx={{ color: '#FDFDFD', fontSize: 13, lineHeight: '16px', fontFamily: 'Inter, sans-serif' }}>
      {loading ? (
        'Checking matching people...'
      ) : (
        <>
          <Box component="span" sx={{ fontWeight: 600 }}>
            {count} member{count === 1 ? '' : 's'}
          </Box>{' '}
          {count === 1 ? 'matches' : 'match'} the audience - invited when you click Invite &amp; Finish
        </>
      )}
    </Typography>
  </Box>
);

const headerStyle = {
  borderBottom: "none",
  bgcolor: "#0F0F0F",
  color: "#868686",
  textTransform: "uppercase",
  fontSize: 12,
  fontWeight: 600,
  fontFamily: "Inter, sans-serif"
};


const HeaderSortable = ({
  title,
  field,
  onMouseEnter,
  onMouseLeave,
  onClick,
  filterType,
  selectedField,
  isHovered
}: any) => (
  <Box
    display="flex"
    alignItems="center"
    className="cursor-pointer"
    onMouseEnter={() => onMouseEnter(field)}
    onMouseLeave={onMouseLeave}
    onClick={() => onClick(field)}
  >
    {title}

    <ArrowUpwardIcon
      sx={{
        color: "#ABB5BE",
        width: 15,
        height: 15,
        ml: 0.5,
        opacity:
          (filterType === "ASC" && selectedField === field) ||
          (isHovered === field && (filterType !== "DESC" || selectedField !== field))
            ? 1
            : 0
      }}
    />

    <ArrowDownwardIcon
      sx={{
        color: "#ABB5BE",
        width: 15,
        height: 15,
        opacity: filterType === "DESC" && selectedField === field ? 1 : 0
      }}
    />
  </Box>
);


interface ProgramUsersProps {
  /** Creation-flow revamp (the Members step of every build): replaces the
   *  enroll-on-save Auto Invite panel with an Any/All Audience editor +
   *  dynamically-computed "who will be invited" list. Nothing enrolls from
   *  the audience here — the footer's "Invite & Finish" does. Launched
   *  programs (default false) keep the legacy Auto Invite behaviour. */
  creationFlow?: boolean;
  /** creationFlow only: true once an audience is set or someone was invited
   *  by name — the condition for Invite & Finish. */
  onInviteReadinessChange?: (ready: boolean) => void;
}

const ProgramUsers = ({ creationFlow = false, onInviteReadinessChange }: ProgramUsersProps = {}) => {
  const params = useParams<{ id?: string; orgId?: string }>();
  const urlGrpId = params.id || '';
  const orgId = params.orgId || '';
  const { state } = useProgramCreation();
  const grpId = state.groupId || urlGrpId;
  const { isMasterclass, isMentorship } = useModule();
  const w = useMemberWord();
  const showAutoInviteMenteesWarning =
    state.programType === 'mentorship' ||
    state.programType === 'guided-masterclass' ||
    (state.programType === null && isMentorship);
  const groupUsers = useAppSelector((state) => state.groupUsers);
  const profileOrgMemberAttributes = useAppSelector((state) => state.userProfile.data?.orgMemberAttributes);
  const [showProfile, setShowProfile] = useState(false);
  const groupDetails = useAppSelector((state) => state.groupDetails.data);
  // A program built for roles in Publish Training (any category) is for its roles only: its roleIds, on
  // GET /group/{grpId} (see capability-setup/create/roleLock.ts). The creation flow has its own step.
  const roleLock = useRoleLock(!creationFlow && groupDetails?.grpId === grpId ? groupDetails?.roleIds : null);
  const showCompany = groupDetails?.userOptionalFields?.companyName ? true : false;
  const [activeUserId, setActiveUserId] = useState('');
  const dispatch = useAppDispatch();

  const [openDialog, setOpenDialog] = React.useState(false);
  const [openUploadUsers, setOpenUploadUsers] = React.useState(false);
  const [openAutoInvite, setOpenAutoInvite] = React.useState(false);
  const [bulkUserLoading, setBulkUserLoading] = useState(false);
  const [autoInviteAll, setAutoInviteAll] = useState(false);
  const [autoInviteAttributes, setAutoInviteAttributes] = useState<string[]>([]);
  const [autoInviteLoading, setAutoInviteLoading] = useState(false);
  const [attributesLoading, setAttributesLoading] = useState(false);
  const [attributeOptions, setAttributeOptions] = useState<{ value: string; label: string }[]>([]);
  const [attributeGroups, setAttributeGroups] = useState<
    { _id?: string; name: string; values: { _id?: string; value: string; selected?: boolean }[] }[]
  >([]);
  const [autoInviteDropdownOpen, setAutoInviteDropdownOpen] = useState(false);
  const autoInviteAnchorRef = useRef<HTMLDivElement>(null);
  const initialGrpMemberValueIdsRef = useRef<Set<string>>(new Set());

  const [scrollToUserCall, setScrollToUserCall] = useState(false);
  const [closedUserId, setClosedUserId] = useState<any>(null);
  const [selectedField, setSelectedField] = useState('');
  const [filterType, setFilterType] = useState<'Normal' | 'ASC' | 'DESC'>('Normal');
  const [isHovered, setIsHovered] = useState('');
  const [viewMode, setViewMode] = useState<'active' | 'invited'>('active');
  const [searchInput, setSearchInput] = useState('');
  const [searchName, setSearchName] = useState('');
  const showGoalProgress =
    getGoalProgressShowOrNot(groupUsers.data?.showGoalProgress) && !isMentorship;
  const classs = adminPanel();
  const [viewAnswerOpen, setViewAnswerOpen] = useState(false);
  const [taskLoading, setTasksLoading] = useState(false);
  const [tasksData, setTasksData] = useState<IAllTaskData | null>(null);
  const handleViewAnswer = (flag: boolean) => setViewAnswerOpen(flag);
  const initialPageSize = 30; // página 1
  const nextPageSize = 20; // página 2+
  const [pageNumber, setPageNumber] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const isFetchingMoreRef = useRef(false);
  const tableContainerRef = useRef<HTMLDivElement | null>(null);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const loadMoreSentinelRef = useRef<HTMLTableRowElement | null>(null);


  /** Search */
  const [searchValue, setSearchValue] = useState('');

  const invitedUserIds = useMemo(() => {
    const invited = groupUsers.data?.invitedUsers || [];
    const ids = new Set<string>();
    invited.forEach((user) => {
      if (user.userId) ids.add(String(user.userId));
      if (user.invitationId) ids.add(String(user.invitationId));
      if (user.email) ids.add(String(user.email).toLowerCase());
    });
    return ids;
  }, [groupUsers.data?.invitedUsers]);

  const baseUsers = useMemo(() => {
    const users = groupUsers.data?.users || [];
    return users.filter((user) => {
      if (user.userId && invitedUserIds.has(String(user.userId))) return false;
      if (user.email && invitedUserIds.has(String(user.email).toLowerCase())) return false;
      return true;
    });
  }, [groupUsers.data?.users, invitedUserIds]);

  // Mantém a mesma lógica de filtro por nome (mesmo sem input visual por enquanto)
  const filteredUsers =
    baseUsers.filter((user) =>
      user.name.toLowerCase().includes(searchValue.toLowerCase())
    ) || [];

  const handleOpenTasks = async (userId: string) => {
    handleViewAnswer(true);
    setTasksLoading(true);
    try {
      const response = await API.getAllTasks({ grpId, userId });
      if (response.status === 200) {
        setTasksData(response.data);
        setTasksLoading(false);
      }
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Lessons failed to load'));
      setTasksLoading(false);
    }
  };

  const handleMouseEnter = (fieldName: string) => {
    setIsHovered(fieldName);
  };
  const handleMouseLeave = () => {
    setIsHovered('');
  };
  const handleUserClosedId = (userIds: any) => {
    setClosedUserId(userIds);
  };
  // Program lock: adding audience / inviting on a locked program is gated —
  // warn the admin and offer to unlock, then run the intended action.
  const isLocked = groupDetails?.locked === true;
  const [lockedWarnOpen, setLockedWarnOpen] = useState(false);
  const [unlockBusy, setUnlockBusy] = useState(false);
  const pendingLockedActionRef = useRef<(() => void) | null>(null);
  const runIfUnlocked = (action: () => void) => {
    if (isLocked) {
      pendingLockedActionRef.current = action;
      setLockedWarnOpen(true);
    } else {
      action();
    }
  };
  const handleConfirmUnlock = async () => {
    if (!grpId) return;
    setUnlockBusy(true);
    try {
      await API.updateProgramLock({ grpId, locked: false });
      // Merge, don't replace — updateGroupData would swap the whole group doc
      // for `{ locked: false }` and blank the page behind the dialog.
      dispatch(grpDetailsActions.updateGroupInfo({ locked: false }));
      setLockedWarnOpen(false);
      const action = pendingLockedActionRef.current;
      pendingLockedActionRef.current = null;
      if (action) action();
    } catch (e: any) {
      toast.error(e?.response?.data?.message || "Couldn't unlock the program");
    } finally {
      setUnlockBusy(false);
    }
  };

  const handleClickOpenDialog = () => {
    runIfUnlocked(() => setOpenDialog(true));
  };
  const handleClickUploadUsers = () => {
    setOpenUploadUsers(true);
  };
  const handleOpenAutoInvite = () => {
    runIfUnlocked(() => setOpenAutoInvite(true));
  };
  const handleCloseUploadUsers = () => {
    setOpenUploadUsers(false);
    setErrorMessage('');
    setbulkFileName('');
    setProcessedFile(null);
  };
  const handleCloseAutoInvite = () => {
    setOpenAutoInvite(false);
  };

  /** Export Button */
  const handleClickExport = () => {
    // Mantém comportamento atual: apenas aviso
    toast.info('Export coming soon');
  };

  const [exportLoader, setExportLoader] = useState(false);
  const { location } = getUserDetails();
  const handleClickExportExcel = async (plan: boolean) => {
    toast.success('Your report will be emailed to you shortly');
    setExportLoader(true);
    try {
      await API.exportUsers({ grpId, location, orgId, plan });
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Report failed to export'));
    } finally {
      setExportLoader(false);
    }
  };

  const isObjectId = (val: string) => /^[a-f0-9]{24}$/i.test(val);

  const normalizeMemberAttributes = (payload: any) => {
    const data = payload?.data ?? payload ?? {};
    const orgAttrs = data?.orgMemberAttributes;
    // Prefer orgMemberAttributes when it has real group objects; skip if empty/only IDs
    const rawAttributes =
      (Array.isArray(orgAttrs) && orgAttrs.length > 0 && typeof orgAttrs[0] === 'object' ? orgAttrs : null) ??
      data?.attributes ??
      (Array.isArray(data?.memberAttributes) && data.memberAttributes.length > 0 && typeof data.memberAttributes[0] === 'object' ? data.memberAttributes : null) ??
      [];
    const groupSelectedIds = Array.isArray(data?.grpMemberAttributes) ? data.grpMemberAttributes : [];
    const options: { value: string; label: string }[] = [];
    const selectedValues: string[] = [];
    const groups: { _id?: string; name: string; values: { _id?: string; value: string; selected?: boolean }[] }[] = [];
    const inviteAll =
      Boolean(data?.inviteAll) ||
      Boolean(data?.inviteAllMembers) ||
      Boolean(data?.inviteAllAttributes);

    const pushOption = (groupName: string | undefined, option: any) => {
      if (option === null || option === undefined) return;
      const rawValue =
        typeof option === 'string'
          ? option
          : option.value ?? option.label ?? option.name ?? option.id;
      const value = rawValue !== undefined && rawValue !== null ? String(rawValue) : '';
      if (!value) return;
      if (value === null || value === undefined) return;
      const label =
        typeof option === 'string'
          ? option
          : option.label ?? option.name ?? option.value ?? option.id;
      const key = groupName ? `${groupName}||${value}` : value;
      options.push({
        value: key,
        label: groupName ? `${groupName}: ${label}` : String(label)
      });
    };

    const pushSelected = (selected: any) => {
      if (!Array.isArray(selected)) return;
      selected.forEach((value) => {
        const normalized =
          typeof value === 'string' ? value : value?.id ?? value?.value ?? value?.label ?? value?.name;
        if (normalized !== null && normalized !== undefined) {
          selectedValues.push(String(normalized));
        }
      });
    };

    if (Array.isArray(rawAttributes)) {
      rawAttributes.forEach((group) => {
        if (typeof group === 'string') {
          // Skip raw ObjectIds — they have no label to display
          if (isObjectId(group)) return;
          pushOption(undefined, group);
          groups.push({ _id: '', name: group, values: [] });
          return;
        }
        const groupName = group?.name ?? group?.title ?? group?.label ?? group?.attributeName ?? group?.key;
        const groupOptions =
          group?.values ??
          group?.options ??
          group?.attributes ??
          group?.items ??
          group?.list ??
          group?.choices ??
          [];
        const normalizedValues = Array.isArray(groupOptions)
          ? groupOptions
              .map((option: any) => {
                if (typeof option === 'string') {
                  if (isObjectId(option)) return null;
                  return { _id: '', value: option, selected: true };
                }
                const value = option?.value ?? option?.label ?? option?.name ?? '';
                if (!value) return null;
                return {
                  _id: option?._id ?? option?.id ?? '',
                  value,
                  selected:
                    option?.selected ?? (option?._id ? groupSelectedIds.includes(option._id) : false)
                };
              })
              .filter(Boolean)
          : [];
        if (Array.isArray(groupOptions)) {
          groupOptions.forEach((option: any) => pushOption(groupName, option));
        }
        groups.push({
          _id: group?._id ?? group?.id,
          name: groupName ?? 'Attributes',
          values: normalizedValues as any[]
        });
        normalizedValues.forEach((item: any) => {
          if (item?.selected) {
            selectedValues.push(`${groupName ?? 'Attributes'}||${item.value}`);
          }
        });
        pushSelected(
          group?.selected ??
            group?.selectedValues ??
            group?.assigned ??
            group?.programValues ??
            group?.selectedAttributes
        );
      });
    } else if (rawAttributes && typeof rawAttributes === 'object') {
      Object.entries(rawAttributes).forEach(([groupName, groupOptions]) => {
        if (Array.isArray(groupOptions)) {
          groupOptions.forEach((option) => pushOption(groupName, option));
          groups.push({
            _id: '',
            name: groupName,
            values: groupOptions.map((option: any) => {
              if (typeof option === 'string') return { _id: '', value: option, selected: true };
              const value = option?.value ?? option?.label ?? option?.name ?? '';
              return { _id: option?._id ?? option?.id ?? '', value, selected: option?.selected ?? false };
            })
          });
        }
      });
    }

    const explicitSelected =
      data?.selectedAttributes ?? data?.programAttributes ?? data?.selected ?? data?.assignedAttributes;
    if (Array.isArray(explicitSelected) && explicitSelected.length) {
      selectedValues.length = 0;
      explicitSelected.forEach((value) => {
        if (typeof value === 'string') {
          groups.forEach((group) => {
            const found = group.values.find((item) => item.value === value);
            if (found) selectedValues.push(`${group.name}||${value}`);
          });
          return;
        }
        const groupName = value?.group ?? value?.groupName ?? value?.attribute ?? value?.name;
        const val = value?.value ?? value?.label ?? value?.id;
        if (groupName && val) {
          selectedValues.push(`${groupName}||${val}`);
        }
      });
    }

    return { options, selectedValues, inviteAll, groups };
  };

  const loadMemberAttributes = async () => {
    if (!grpId) return;
    setAttributesLoading(true);
    try {
      const response = await API.getGroupMemberAttributes({ grpId });
      let inner = unwrapEnvelope(response) as Record<string, unknown> & {
        orgMemberAttributes?: unknown;
        grpMemberAttributes?: string[];
        inviteAll?: boolean;
        inviteAllMembers?: boolean;
        inviteAllAttributes?: boolean;
      };

      if (
        Array.isArray(inner.orgMemberAttributes) &&
        inner.orgMemberAttributes.length === 0 &&
        Array.isArray(profileOrgMemberAttributes) &&
        profileOrgMemberAttributes.length > 0
      ) {
        inner = { ...inner, orgMemberAttributes: profileOrgMemberAttributes };
      }

      if (Array.isArray(inner.orgMemberAttributes)) {
        inner = {
          ...inner,
          orgMemberAttributes: filterHiddenMemberAttributes(inner.orgMemberAttributes as any)
        };
      }

      const { orgCatalog, grpIds } = parseGroupMemberAttributesResponse({ data: inner } as unknown, undefined);
      const merged = mergeGrpSelection(orgCatalog, grpIds);
      initialGrpMemberValueIdsRef.current = new Set(grpIds.filter(isMongoObjectIdString));

      const hasAnyValues = merged.some((g) => (g.values || []).length > 0);
      if (hasAnyValues) {
        const options: { value: string; label: string }[] = [];
        const selectedValues: string[] = [];
        const inviteAll =
          Boolean(inner?.inviteAll) ||
          Boolean(inner?.inviteAllMembers) ||
          Boolean(inner?.inviteAllAttributes);

        for (const group of merged) {
          const gName = group.name;
          for (const v of group.values || []) {
            options.push({
              value: `${gName}||${v.value}`,
              label: `${gName}: ${v.value}`
            });
            if (v.selected) selectedValues.push(`${gName}||${v.value}`);
          }
        }

        setAttributeOptions(options);
        setAttributeGroups(merged);
        setAutoInviteAll(inviteAll);
        setAutoInviteAttributes(inviteAll ? [] : selectedValues);
      } else {
        const normalized = normalizeMemberAttributes(inner);
        setAttributeOptions(normalized.options);
        setAttributeGroups(normalized.groups);
        setAutoInviteAll(normalized.inviteAll);
        setAutoInviteAttributes(normalized.inviteAll ? [] : normalized.selectedValues);
        const rawGrp = Array.isArray(inner?.grpMemberAttributes) ? inner.grpMemberAttributes : [];
        initialGrpMemberValueIdsRef.current = new Set(rawGrp.map(String).filter(isMongoObjectIdString));
      }
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Attributes could not be loaded. Refresh the page and try again.'));
    } finally {
      setAttributesLoading(false);
    }
  };

  const handleAutoInviteSubmit = async () => {
    if (!grpId) return;
    setAutoInviteLoading(true);
    try {
      const selectedKeys = new Set(autoInviteAttributes);
      const attemptedRemoval = detectAttemptedGrpDeselectionFromProgramUi(
        initialGrpMemberValueIdsRef.current,
        attributeGroups,
        autoInviteAll,
        selectedKeys
      );
      const payload = buildGroupPutPayload(
        attributeGroups.map((group) => ({
          _id: group._id ?? '',
          name: group.name,
          values: (group.values || []).map((item) => ({
            _id: item._id ?? '',
            value: item.value,
            selected: autoInviteAll ? true : selectedKeys.has(`${group.name}||${item.value}`)
          }))
        }))
      );
      const putRes = await API.updateGroupMemberAttributes({
        grpId,
        data: payload
      });
      const added =
        (putRes as any)?.data?.data?.added ??
        (putRes as any)?.data?.added ??
        (putRes as any)?.added;

      const reloadRes = await API.getGroupMemberAttributes({ grpId });
      let innerReload = unwrapEnvelope(reloadRes) as Record<string, unknown> & {
        orgMemberAttributes?: unknown;
        grpMemberAttributes?: string[];
      };
      if (
        Array.isArray(innerReload.orgMemberAttributes) &&
        innerReload.orgMemberAttributes.length === 0 &&
        Array.isArray(profileOrgMemberAttributes) &&
        profileOrgMemberAttributes.length > 0
      ) {
        innerReload = { ...innerReload, orgMemberAttributes: profileOrgMemberAttributes };
      }
      if (Array.isArray(innerReload.orgMemberAttributes)) {
        innerReload = {
          ...innerReload,
          orgMemberAttributes: filterHiddenMemberAttributes(innerReload.orgMemberAttributes as any)
        };
      }
      const { orgCatalog: catR } = parseGroupMemberAttributesResponse({ data: innerReload } as unknown, undefined);
      dispatch(setOrgMemberAttributes(catR));

      await loadMemberAttributes();

      let msg =
        typeof added === 'number'
          ? `${added} attributes added. Auto-enroll preferences updated.`
          : 'Auto-enroll updated.';
      if (attemptedRemoval) {
        msg +=
          ' Note: removing existing Auto-enroll selections is not supported yet, so those changes may not take effect.';
      }
      toast.success(msg);
      setOpenAutoInvite(false);
      setPageNumber(1);
      const nameParam = searchName.trim() || undefined;
      dispatch(fetchGroupUsers({ grpId, pageNumber: 1, pageSize: initialPageSize, name: nameParam }));
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Auto-enroll could not be updated. Try again.'));
    } finally {
      setAutoInviteLoading(false);
    }
  };

  useEffect(() => {
    if (!openAutoInvite) return;
    loadMemberAttributes();
  }, [openAutoInvite, grpId]);

  /* ── Creation-flow Audience section (§7) ─────────────────────────────────
     The audience picked while creating, editable here: any org attribute
     value, Any/All per list, or all learners. Below it, the live list of who
     that audience matches (audiencePreview — getGroupUsers only returns people
     already enrolled). Saves are save-only (enroll:false, and the BE holds
     enrolment until Invite & Finish anyway). */
  const { catalog: audienceCatalog, labelById: audienceLabelById } = useOrgAudienceOptions();
  const [audiencePreview, setAudiencePreview] = useState<{
    count: number;
    members: {
      id: string;
      name: string;
      /** Absent until the BE preview ships lastName + attributes. */
      lastName?: string;
      email: string;
      attributes?: string[];
      enrolled: boolean;
    }[];
  } | null>(null);
  const [audiencePreviewLoading, setAudiencePreviewLoading] = useState(false);
  const [audienceSaving, setAudienceSaving] = useState(false);
  const [audienceDraft, setAudienceDraft] = useState<AudienceRule[]>([]);
  const [audienceAllLearners, setAudienceAllLearners] = useState(false);
  // The editor is seeded from what's stored once; after that the draft leads.
  const audienceSeededRef = useRef(false);
  const audienceSaveTimerRef = useRef<number | undefined>(undefined);

  const refreshAudiencePreview = async () => {
    if (!grpId) return;
    setAudiencePreviewLoading(true);
    try {
      const res: any = await API.previewProgramAudience({ id: grpId, includeMembers: true, ...getLLAuthHeaders() });
      const data = res?.data?.data ?? res?.data ?? {};
      setAudiencePreview({
        count: typeof data.matchedCount === 'number' ? data.matchedCount : 0,
        members: Array.isArray(data.members) ? data.members : []
      });
      if (!audienceSeededRef.current) {
        audienceSeededRef.current = true;
        setAudienceDraft(Array.isArray(data.audienceRules) ? data.audienceRules : []);
        setAudienceAllLearners(Boolean(data.enrollAll));
      }
      const manualInvites = typeof data.manualInviteCount === 'number' ? data.manualInviteCount : 0;
      onInviteReadinessChange?.(Boolean(data.audienceSet) || manualInvites > 0);
    } catch (e) {
      console.error('[ProgramUsers] audience preview failed', e);
      setAudiencePreview({ count: 0, members: [] });
    } finally {
      setAudiencePreviewLoading(false);
    }
  };

  useEffect(() => {
    if (!creationFlow || !grpId) return;
    refreshAudiencePreview();
  }, [creationFlow, grpId]);

  // Inviting someone by name changes the Invite & Finish gate — recheck it.
  const programPeopleCount =
    (groupUsers.data?.users?.length ?? 0) + (groupUsers.data?.invitedUsers?.length ?? 0);
  useEffect(() => {
    if (!creationFlow || !grpId || !audienceSeededRef.current) return;
    refreshAudiencePreview();
  }, [programPeopleCount]);

  useEffect(() => () => window.clearTimeout(audienceSaveTimerRef.current), []);

  // Debounced so ticking several values in a row saves once.
  const saveAudience = (rules: AudienceRule[], allLearners: boolean) => {
    if (!grpId) return;
    window.clearTimeout(audienceSaveTimerRef.current);
    audienceSaveTimerRef.current = window.setTimeout(async () => {
      setAudienceSaving(true);
      try {
        const participating = participatingAudienceRules(rules);
        await API.patchProgram({
          id: grpId,
          body: {
            audienceRules: allLearners ? [] : participating,
            enrollmentMode: allLearners ? 'auto-enroll' : hasAudienceTargeting(participating) ? 'proceed' : 'manual',
            enroll: false
          },
          ...getLLAuthHeaders()
        });
        await refreshAudiencePreview();
      } catch (e) {
        toast.error(_.get(e, 'response.data.message', 'Failed to update the audience'));
      } finally {
        setAudienceSaving(false);
      }
    }, 500);
  };

  const handleAudienceRulesChange = (next: AudienceRule[]) => {
    setAudienceDraft(next);
    saveAudience(next, audienceAllLearners);
  };

  const handleAllLearnersChange = (next: boolean) => {
    setAudienceAllLearners(next);
    saveAudience(audienceDraft, next);
  };

  const handleClickDevelopmentPlan = async (plan: boolean) => {
    toast.success('Your report will be emailed to you shortly');
    setExportLoader(true);
    try {
      await API.exportDevelopmentPlan({ grpId, location, orgId, plan });
    } catch (e) {
      toast.error(_.get(e, 'response.data.message', 'Report failed to export'));
    } finally {
      setExportLoader(false);
    }
  };

  const handleMemberDevelopmentPlan = (plan: boolean) => {
    handleClickDevelopmentPlan(plan);
  };

  

  /**  Upload Files in Bulk................... */
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [bulkfileName, setbulkFileName] = useState<string>('');
  const [processedFile, setProcessedFile] = useState<File | null>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleBulkFileChanges = (event: ChangeEvent<HTMLInputElement>) => {
    const selectFile = event.target.files?.[0];
    if (selectFile) {
      handleFileInputChange(selectFile);
    }
  };

  const handleFileInputChange = async (selectFile: File) => {
    const maxFileSize = 50 * 1024;

    if (!selectFile || !selectFile.name.endsWith('.xlsx')) {
      toast.error('Only xlsx files can be uploaded');
      return;
    }
    if (selectFile.size > maxFileSize) {
      toast.error('The max file size is 50KB');
      return;
    }

    try {
      // Read the workbook and trim leading/trailing whitespace from every text cell
      // so that entries like "user@example.com " don't fail on the server.
      const XLSX = await loadXlsx();
      const arrayBuffer = await selectFile.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });
      workbook.SheetNames.forEach((sheetName) => {
        const sheet = workbook.Sheets[sheetName];
        Object.keys(sheet).forEach((cellKey) => {
          if (cellKey.startsWith('!')) return;
          const cell = sheet[cellKey];
          if (cell && cell.t === 's' && typeof cell.v === 'string') {
            cell.v = cell.v.trim();
            cell.w = cell.v;
          }
        });
      });
      const processed = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
      const blob = new Blob([processed], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      setProcessedFile(new File([blob], selectFile.name, { type: blob.type }));
      setbulkFileName(selectFile.name);
    } catch {
      toast.error('The file could not be processed. Try again.');
    }
  };

  const [errorMessage, setErrorMessage] = useState<string>('');
  const handlebulkSubmit = async () => {
    setBulkUserLoading(true);
    if (bulkfileName && processedFile) {
      const bulkFormData = new FormData();
      bulkFormData.append('xlsx', processedFile);

      try {
        const response = await API.bulkFilesUpload({
          data: bulkFormData,
          orgId,
          grpId
        });

        if (response.status === 200) {
          if (response.data.invitedUsers) {
            setPageNumber(1);
            const nameParam = searchName.trim() || undefined;
            dispatch(fetchGroupUsers({ grpId, pageNumber: 1, pageSize: initialPageSize, name: nameParam }));
          }
          toast.success(_.get(response, 'data.message'));
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        } else if (response.status === 207 && response.statusText === 'Multi-Status') {
          toast.success(_.get(response, 'data.message'));
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        } else {
          toast.error('The file could not be uploaded. Try again.');
          handleCloseUploadUsers();
          setBulkUserLoading(false);
        }
      } catch (error) {
        setBulkUserLoading(false);
        toast.error('The file could not be uploaded. Try again.');
      }
    } else {
      setBulkUserLoading(false);
      setErrorMessage('*Please Choose a File to Upload.');
      return;
    }
  };

  // Download template
  const handleDownload = async () => {
    const data = [
      ['First Name', 'Last Name', 'Email', 'Role'],
      ['oscar', 'robertson', 'oscarrobertson24@gmail.rcom', 'mentor'],
      ['Magic', 'johnson', 'johnmagic@gmail.com', 'mentee'],
      ['John', 'Smith', 'jsmith007@gmail.com', 'admin']
    ];

    const filename = 'template.xlsx';
    const XLSX = await loadXlsx();
    const sheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, filename);
  };

  useEffect(() => {
    if (!grpId) return;
    const t = setTimeout(() => {
      setSearchName(searchInput.trim());
    }, 400);
    return () => clearTimeout(t);
  }, [searchInput, grpId]);

  useEffect(() => {
    if (grpId && grpId !== 'admin') {
      setPageNumber(1);
      const nameParam = searchName.trim() || undefined;
      dispatch(fetchGroupUsers({ grpId, pageNumber: 1, pageSize: initialPageSize, name: nameParam }));
    }
  }, [dispatch, grpId, initialPageSize, searchName]);

  useEffect(() => {
    if (grpId && grpId !== 'admin' && orgId) {
      dispatch(fetchAllGroupsList({ orgId: orgId, groupId: grpId }));
    }
  }, [dispatch, grpId, orgId]);

  const isInitialLoad = !groupUsers.data?.users?.length && !groupUsers.data?.invitedUsers?.length;
  const pagination = groupUsers.data?.pagination;
  const totalUsers = pagination?.total ?? (groupUsers.data?.users?.length || 0);
  const currentCount = groupUsers.data?.users?.length || 0;
  const hasMoreUsers =
    Boolean(pagination && currentCount < pagination.total) ||
    (pagination == null && currentCount === (pageNumber === 1 ? initialPageSize : nextPageSize));
  const fetchNextPage = useCallback(() => {
    if (!grpId || isFetchingMoreRef.current || groupUsers.loading || !hasMoreUsers) return;
    const nextPage = pageNumber + 1;
    isFetchingMoreRef.current = true;
    setIsFetchingMore(true);
    const nameParam = searchName.trim() || undefined;
    dispatch(fetchGroupUsers({ grpId, pageNumber: nextPage, pageSize: nextPageSize, name: nameParam }))
      .unwrap()
      .then(() => setPageNumber(nextPage))
      .finally(() => {
        isFetchingMoreRef.current = false;
        setIsFetchingMore(false);
      });
  }, [dispatch, grpId, hasMoreUsers, pageNumber, nextPageSize, searchName, groupUsers.loading]);

  // Infinite scroll: observer com root = scroll container (mainBody) para disparar ao chegar perto do fim
  // + fallback com viewport (root: null) quando só tem página 1 e o sentinela já está visível
  useEffect(() => {
    if (viewMode !== 'active' || !hasMoreUsers) return;
    const sentinel = loadMoreSentinelRef.current;
    const root = scrollContainerRef.current ?? null;
    const scrollEl = tableContainerRef.current;
    const cleanupFns: (() => void)[] = [];

    if (sentinel) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) fetchNextPage();
        },
        { root, rootMargin: '0px 0px 30% 0px', threshold: 0 }
      );
      observer.observe(sentinel);
      cleanupFns.push(() => observer.disconnect());
    }

    if (scrollEl) {
      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = scrollEl;
        const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        if (distanceFromBottom < scrollHeight * 0.5) fetchNextPage();
      };
      scrollEl.addEventListener('scroll', handleScroll, { passive: true });
      cleanupFns.push(() => scrollEl.removeEventListener('scroll', handleScroll));
    }

    return () => cleanupFns.forEach((fn) => fn());
  }, [viewMode, hasMoreUsers, fetchNextPage]);

  if (groupUsers.error) {
    return <Box>{groupUsers.errorText}</Box>;
  }

  let sortedUsers: any[] = [];

  const clickFilterHandle = (clickedField: string) => {
    let filterAppliedFlag = false;
    let filterTypeValue: 'Normal' | 'ASC' | 'DESC' = filterType;

    if (selectedField === clickedField) {
      if (filterType === 'Normal') {
        filterTypeValue = 'ASC';
      } else if (filterType === 'ASC') {
        filterTypeValue = 'DESC';
      } else {
        filterTypeValue = 'Normal';
      }
    } else {
      filterTypeValue = 'ASC';
    }

    setFilterType(filterTypeValue);
    setSelectedField(clickedField);

    if (!filterAppliedFlag) {
      filterAppliedFlag = true;
      if (filterTypeValue === 'Normal') {
        if (grpId) {
          setPageNumber(1);
          const nameParam = searchName.trim() || undefined;
          dispatch(fetchGroupUsers({ grpId, pageNumber: 1, pageSize: initialPageSize, name: nameParam }));
        }
      } else {
        if (
          groupUsers.data &&
          (groupUsers.data.users.length > 0 || groupUsers.data.invitedUsers.length > 0)
        ) {
          // base
          sortedUsers = groupUsers.data.users.slice();

          // name filter
          if (clickedField === 'name') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = sortedUsers
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name));
            } else {
              sortedUsers = sortedUsers
                .slice()
                .sort((a, b) => b.name.localeCompare(a.name));
            }
          }

          // messages count filter
          if (clickedField === 'messages') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.sentMessages - a.sentMessages);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.sentMessages - b.sentMessages);
            }
          }

          // goal progress filter
          if (clickedField === 'goalProgress') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (b.goalProgress ?? 0) - (a.goalProgress ?? 0)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (a.goalProgress ?? 0) - (b.goalProgress ?? 0)
                );
            }
          }

          // Program role filter
          if (clickedField === 'role') {
            const rolePriority = {
              admin: 1,
              mentee: 2,
              mentor: 3
            };
            const getHighestRolePriority = (user: IGroupUser): number => {
              let minRolePriority = Number.MAX_SAFE_INTEGER;
              user.role.forEach((role) => {
                const priority =
                  rolePriority[role as keyof typeof rolePriority];
                if (priority < minRolePriority) {
                  minRolePriority = priority;
                }
              });
              return minRolePriority;
            };
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => {
                  const highestRoleA = getHighestRolePriority(a);
                  const highestRoleB = getHighestRolePriority(b);
                  return highestRoleA - highestRoleB;
                });
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => {
                  const highestRoleA = getHighestRolePriority(b);
                  const highestRoleB = getHighestRolePriority(a);
                  return highestRoleA - highestRoleB;
                });
            }
          }

          // xpPoints filter
          if (clickedField === 'xpPoints') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (b.xpPoints ?? 0) - (a.xpPoints ?? 0)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    (a.xpPoints ?? 0) - (b.xpPoints ?? 0)
                );
            }
          }

          // lastLogin filter
          if (clickedField === 'lastLogin') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.lastLogin - a.lastLogin);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.lastLogin - b.lastLogin);
            }
          }

          // meetings filter
          if (clickedField === 'meetings') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => b.meetings - a.meetings);
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) => a.meetings - b.meetings);
            }
          }

          // onboardingStatus filter
          if (clickedField === 'onboardingStatus') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  a.onboardStatus === 'engaged' && isMasterclass
                    ? 'adopted'.localeCompare(b.onboardStatus)
                    : a.onboardStatus.localeCompare(b.onboardStatus)
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  b.onboardStatus === 'engaged' && isMasterclass
                    ? 'adopted'.localeCompare(a.onboardStatus)
                    : b.onboardStatus.localeCompare(a.onboardStatus)
                );
            }
          }

          if (clickedField === 'onboardedDate') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    new Date(a.onboardedDate).getTime() -
                    new Date(b.onboardedDate).getTime()
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b.onboardedDate).getTime() -
                    new Date(a.onboardedDate).getTime()
                );
            }
          }

          if (clickedField === 'company') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (a.company?.companyName || '').localeCompare(
                    b.company?.companyName || ''
                  )
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (b.company?.companyName || '').localeCompare(
                    a.company?.companyName || ''
                  )
                );
            }
          }

          if (clickedField === 'location') {
            if (filterTypeValue === 'ASC') {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (a.company?.companyLocation || '').localeCompare(
                    b.company?.companyLocation || ''
                  )
                );
            } else {
              sortedUsers = groupUsers.data.users
                .slice()
                .sort((a, b) =>
                  (b.company?.companyLocation || '').localeCompare(
                    a.company?.companyLocation || ''
                  )
                );
            }
          }

          dispatch(groupUsersActions.updateGroupUserList(sortedUsers));
        }
      }
    }
  };
const headerSortProps = {
  onMouseEnter: handleMouseEnter,
  onMouseLeave: handleMouseLeave,
  onClick: clickFilterHandle,
  filterType,
  selectedField,
  isHovered
};

  const activeUsersCount = totalUsers;
  const invitedUsersCount = groupUsers.data?.invitedUsers?.length || 0;
  const membersLabel =
    viewMode === 'active'
      ? `${activeUsersCount} Active`
      : `${invitedUsersCount} Invited`;

  const listLoading = groupUsers.loading && isInitialLoad;
  sortedUsers = groupUsers.data?.users ?? [];

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <Box
        ref={scrollContainerRef}
        className={classs.mainBody}
        sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
      >
        {/* Creation-flow Audience section (§7) — choose the audience (Any/All
            per list, or all learners) and see who it matches right now. */}
        {creationFlow && !showProfile && (
          <Box
            sx={{
              mb: 2.5,
              p: 2.5,
              bgcolor: '#0F0F0F',
              borderRadius: '8px',
              border: '1px solid #2A2A2A',
              display: 'flex',
              flexDirection: 'column',
              gap: 2
            }}
          >
            <Box>
              <Typography sx={{ color: '#FDFDFD', fontSize: 16, fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>
                Audience
              </Typography>
            </Box>

            <AudienceRulesEditor
              catalog={audienceCatalog}
              rules={audienceDraft}
              onChange={handleAudienceRulesChange}
              allLearners={audienceAllLearners}
              onAllLearnersChange={handleAllLearnersChange}
            />

            {/* Matching Members — who the audience matches right now, with the
                count note (the number Invite & Finish acts on). */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>
                  Matching people
                </Typography>
                <AudienceMatchNote
                  count={audiencePreview?.count ?? 0}
                  loading={audiencePreviewLoading || audienceSaving}
                />
              </Box>
              {(audiencePreview?.members?.length ?? 0) > 0 && (
                <Box sx={{ border: '1px solid #1C1C1C', borderRadius: '6px', overflow: 'hidden' }}>
                  {/* Column headers */}
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1.6fr 2fr 110px',
                      gap: 1.5,
                      px: 1.5,
                      py: 0.75,
                      bgcolor: '#141414',
                      '& > *': {
                        color: '#868686',
                        fontSize: 11,
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontFamily: 'Inter, sans-serif'
                      }
                    }}
                  >
                    <Typography>First Name</Typography>
                    <Typography>Last Name</Typography>
                    <Typography>Email</Typography>
                    <Typography>Attributes</Typography>
                    <Typography sx={{ textAlign: 'right' }}>Status</Typography>
                  </Box>
                  <Box sx={{ maxHeight: 260, overflowY: 'auto' }}>
                    {audiencePreview!.members.map((m, idx) => {
                      let attributeLabels = (m.attributes || [])
                        .map((id) => audienceLabelById.get(String(id)))
                        .filter(Boolean)
                        .join(', ');
                      // DUMMY: local dev only — the deployed BE preview doesn't send
                      // attributes yet, so borrow two real labels from the org catalog
                      // to refine the UI. Remove once BE programAudiencePreview ships.
                      if (!attributeLabels && process.env.NODE_ENV === 'development') {
                        const labels = Array.from(audienceLabelById.values());
                        if (labels.length > 0) {
                          attributeLabels = [labels[idx % labels.length], labels[(idx * 3 + 1) % labels.length]]
                            .filter((l, i, all) => all.indexOf(l) === i)
                            .join(', ');
                        } else {
                          attributeLabels = ['Sales, London', 'Marketing', 'Engineering, Dublin'][idx % 3];
                        }
                      }
                      return (
                        <Box
                          key={m.id}
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1.6fr 2fr 110px',
                            gap: 1.5,
                            alignItems: 'center',
                            px: 1.5,
                            py: 0.75,
                            borderTop: '1px solid #1C1C1C',
                            '& > *': {
                              fontFamily: 'Inter, sans-serif',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }
                          }}
                        >
                          <Typography sx={{ color: '#FDFDFD', fontSize: 13 }}>{m.name || ''}</Typography>
                          <Typography sx={{ color: '#FDFDFD', fontSize: 13 }}>{m.lastName || ''}</Typography>
                          <Typography sx={{ color: '#868686', fontSize: 12 }}>{m.email}</Typography>
                          <Typography title={attributeLabels} sx={{ color: '#B6B6B6', fontSize: 12 }}>
                            {attributeLabels || 'None'}
                          </Typography>
                          <Typography
                            sx={{
                              color: m.enrolled ? '#4CAF50' : '#F79420',
                              fontSize: 11,
                              fontWeight: 600,
                              textAlign: 'right'
                            }}
                          >
                            {m.enrolled ? 'Already added' : 'Will be enrolled'}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        )}

        {/* Creation flow: invite people by name or in bulk — the same dialogs as
            the launched program's Manual / Bulk Invite. */}
        {creationFlow && !showProfile && (
          <Box
            sx={{
              mb: 2.5,
              p: 2.5,
              bgcolor: '#0F0F0F',
              borderRadius: '8px',
              border: '1px solid #2A2A2A',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}
          >
            <Box sx={{ flex: 1, minWidth: 220 }}>
              <Typography sx={{ color: '#FDFDFD', fontSize: 16, fontFamily: 'Inter, sans-serif', fontWeight: 600 }}>
                Enroll people
              </Typography>
              <Typography sx={{ color: '#868686', fontSize: 13, fontFamily: 'Inter, sans-serif', mt: 0.5 }}>
                Enroll people who aren&apos;t in the audience, one at a time or from a spreadsheet.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <Button
                onClick={handleClickOpenDialog}
                sx={{
                  textTransform: 'none',
                  px: 1.5,
                  py: 1.25,
                  borderRadius: '6px',
                  bgcolor: '#565656',
                  color: '#FDFDFD',
                  fontSize: 13,
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 500,
                  lineHeight: '19.5px',
                  border: '1px solid #0F0F0F',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  '&:hover': { bgcolor: '#666666' }
                }}
              >
                Enroll One Person
              </Button>
              <Button
                onClick={handleClickUploadUsers}
                sx={{
                  textTransform: 'none',
                  px: 1.5,
                  py: 1.25,
                  borderRadius: '6px',
                  bgcolor: '#565656',
                  color: '#FDFDFD',
                  fontSize: 13,
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 500,
                  lineHeight: '19.5px',
                  border: '1px solid #0F0F0F',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  '&:hover': { bgcolor: '#666666' }
                }}
              >
                Bulk Enroll
              </Button>
            </Box>
          </Box>
        )}

        {showProfile ? (
              <ProgramUserDetails
                actievUserId={activeUserId}
                setScrollToUserCall={setScrollToUserCall}
                setShowProfile={setShowProfile}
                grpId={grpId}
                handleUserClosedId={handleUserClosedId}
                handleOpenTasks={handleOpenTasks}
              />
            ) : creationFlow ? null : (
              // Members table — launched programs only. The creation flow shows
              // Matching Members + Invite New Members above instead.
              <Box
                sx={{
                  flex: 1,
                  // Creation flow: the Audience section sits above the table and
                  // doesn't shrink, so without a floor the table collapses to 0
                  // and nothing overflows to scroll. Keep it usable; mainBody scrolls.
                  minHeight: creationFlow ? 420 : 0,
                  bgcolor: '#0F0F0F',
                  borderRadius: '8px',
                  border: '1px solid #2A2A2A',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* HEADER – Figma style */}
                <Box
                  sx={{
                    px: 3,
                    py: 2.5,
                    // Creation flow: grows if the audience note wraps on narrower screens.
                    ...(creationFlow ? { minHeight: 82 } : { height: 82 }),
                    borderBottom: '1px solid #1C1C1C',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2
                  }}
                >

                  {/* Members count + Active / Invited toggle */}
                  <Box
                    sx={{
                      flex: '1 1 0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#B6B6B6',
                        fontSize: 16,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600
                      }}
                    >
                      {membersLabel}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      <Button
                        onClick={() => setViewMode('active')}
                        size="small"
                        sx={{
                          textTransform: 'none',
                          fontSize: 13,
                          fontWeight: 600,
                          color: viewMode === 'active' ? '#FDFDFD' : '#868686',
                          bgcolor: viewMode === 'active' ? '#2A2A2A' : 'transparent',
                          borderRadius: '6px',
                          px: 1.5,
                          py: 0.75,
                          '&:hover': {
                            bgcolor: viewMode === 'active' ? '#2A2A2A' : '#1C1C1C',
                            color: '#FDFDFD'
                          }
                        }}
                      >
                        Active
                      </Button>
                      <Button
                        onClick={() => setViewMode('invited')}
                        size="small"
                        sx={{
                          textTransform: 'none',
                          fontSize: 13,
                          fontWeight: 600,
                          color: viewMode === 'invited' ? '#FDFDFD' : '#868686',
                          bgcolor: viewMode === 'invited' ? '#2A2A2A' : 'transparent',
                          borderRadius: '6px',
                          px: 1.5,
                          py: 0.75,
                          '&:hover': {
                            bgcolor: viewMode === 'invited' ? '#2A2A2A' : '#1C1C1C',
                            color: '#FDFDFD'
                          }
                        }}
                      >
                        Invited
                      </Button>
                    </Box>
                    <TextField
                      size="small"
                      placeholder="Search people..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      sx={{
                        width: 220,
                        '& .MuiOutlinedInput-root': {
                          bgcolor: '#1C1C1C',
                          borderRadius: '6px',
                          fontSize: 13,
                          color: '#FDFDFD',
                          '& fieldset': { borderColor: '#2A2A2A' },
                          '&:hover fieldset': { borderColor: '#404040' },
                          '&.Mui-focused fieldset': { borderColor: '#565656' }
                        },
                        '& .MuiInputBase-input::placeholder': { color: '#868686', opacity: 1 }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start" sx={{ color: '#868686', mr: 0 }}>
                            <SearchIcon sx={{ fontSize: 20 }} />
                          </InputAdornment>
                        )
                      }}
                    />
                    {creationFlow && (
                      <AudienceMatchNote
                        count={audiencePreview?.count ?? 0}
                        loading={audiencePreviewLoading || audienceSaving}
                      />
                    )}
                  </Box>

                  {/* Right buttons */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.25
                    }}
                  >
                    <Button
                      onClick={() => handleClickExportExcel(false)}
                      disabled={exportLoader}
                      sx={{
                        textTransform: 'none',
                        px: 1.75,
                        py: 1.25,
                        borderRadius: '6px',
                        bgcolor: '#1C1C1C',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        lineHeight: '19.5px',
                        '&:hover': {
                          bgcolor: '#262626'
                        },
                        '&.Mui-disabled': buttonDisabledSx
                      }}
                    >
                      {exportLoader ? 'Exporting...' : 'Export Data'}
                    </Button>

                    {/* Auto Invite — hidden in the creation flow, where the
                        Audience section + Invite & Finish replace it (§7). */}
                    {/* A roles-only program takes its people from its roles: nothing to invite by here. */}
                    {roleLock && (
                      <Typography
                        sx={{ color: '#868686', fontSize: 13, fontFamily: 'Inter, sans-serif', maxWidth: 340 }}
                      >
                        For its roles only{roleLock.roleNames.length > 0 ? `: ${roleLock.roleNames.join(', ')}` : ''}.
                        People join by holding one of them.
                      </Typography>
                    )}
                    {!creationFlow && !roleLock && (
                    <Button
                      onClick={handleOpenAutoInvite}
                      sx={{
                        textTransform: 'none',
                        px: 1.5,
                        py: 1.25,
                        borderRadius: '6px',
                        background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': {
                          background: 'linear-gradient(180deg, #FFA63E 0%, #F46B38 100%)'
                        }
                      }}
                    >
                      Auto-Enroll
                    </Button>
                    )}

                    {/* Manual Invite */}
                    {!roleLock && (
                    <Button
                      onClick={handleClickOpenDialog}
                      sx={{
                        textTransform: 'none',
                        px: 1.5,
                        py: 1.25,
                        borderRadius: '6px',
                        bgcolor: '#565656',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        lineHeight: '19.5px',
                        border: '1px solid #0F0F0F',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': {
                          bgcolor: '#666666'
                        }
                      }}
                    >
                      Manual Enroll
                    </Button>
                    )}

                    {/* Bulk Invite */}
                    {!roleLock && (
                    <Button
                      onClick={handleClickUploadUsers}
                      sx={{
                        textTransform: 'none',
                        px: 1.5,
                        py: 1.25,
                        borderRadius: '6px',
                        bgcolor: '#565656',
                        color: '#FDFDFD',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        lineHeight: '19.5px',
                        border: '1px solid #0F0F0F',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        '&:hover': {
                          bgcolor: '#666666'
                        }
                      }}
                    >
                      Bulk Enroll
                    </Button>
                    )}
                  </Box>
                </Box>

                {/* TABLE */}
                <TableContainer
                  className="b-none"
                  ref={tableContainerRef}
                  sx={{
                    flex: 1,
                    bgcolor: '#0F0F0F',
                    overflowY: 'auto'
                  }}
                >
                  <Table
                    className="tableBody"
                    width="100%"
                    aria-label="members table"
                  >
                    {/* HEADER ROW – adaptado pro layout Figma */}
                    <TableHead>
  <TableRow sx={{ bgcolor: "#0F0F0F", height: 48 }}>
    {/* 1 — Checkbox */}
    <TableCell sx={{ width: 22 }} />

    {/* 2 — NAME (flex no figma, mas usamos width fixa equivalente) */}
    <TableCell sx={{ width: 200 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Name
      </Typography>
    </TableCell>

    {/* 3 — ROLE */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Role
      </Typography>
    </TableCell>

    {/* 4 — Last Login */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Last Login
      </Typography>
    </TableCell>

    {/* 5 — Programs */}
    <TableCell sx={{ width: 80 }}>
      <Typography className="uppercase" sx={{ textAlign: "center", color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Messages
      </Typography>
    </TableCell>

    {/* 6 — Onboarding Status */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Onboarding Status
      </Typography>
    </TableCell>

    {/* 7 — Onboarded Date */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Onboarded Date
      </Typography>
    </TableCell>

    {/* 8 — Goal Progress */}
    <TableCell sx={{ width: 140 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Goal Progress
      </Typography>
    </TableCell>

    {/* 9 — Experience Points */}
    <TableCell sx={{ width: 150 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Experience Points
      </Typography>
    </TableCell>

    {/* 10 — Meetings */}
    <TableCell sx={{ width: 100 }}>
      <Typography className="uppercase" sx={{ color: "#868686", fontSize: 12, fontWeight: 600 }}>
        Meetings
      </Typography>
    </TableCell>

    {/* 11 — Actions */}
    <TableCell sx={{ width: 220 }} />
  </TableRow>
</TableHead>


                    <TableBody>
                      {viewMode === 'active' ? (
                        <>
                          {listLoading ? (
                            <TableRow sx={{ bgcolor: '#0F0F0F' }}>
                              <TableCell colSpan={22} sx={{ borderBottom: '1px solid #1C1C1C', py: 6 }}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                  <ThreeDots
                                    height={40}
                                    width={40}
                                    radius={9}
                                    color="#F79420"
                                    ariaLabel="loading"
                                    visible
                                  />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : groupUsers.data?.users && groupUsers.data.users.length > 0 ? (
                            filteredUsers.map((each: IGroupUser) => (
                              <ProgramUserTableRow
                                key={each.userId}
                                data={each}
                                setShowProfile={setShowProfile}
                                setActiveUserId={setActiveUserId}
                                scrollToUserCall={scrollToUserCall}
                                setScrollToUserCall={setScrollToUserCall}
                                closedUserId={closedUserId}
                                showGoalProgress={showGoalProgress}
                                handleOpenTasks={handleOpenTasks}
                                showCompany={showCompany}
                              />
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={22}>
                                <Typography textAlign="center" color="#868686">
                                  No active people in this program yet
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                          {isFetchingMore && (
                            <TableRow sx={{ bgcolor: '#0F0F0F' }}>
                              <TableCell colSpan={22} sx={{ borderBottom: '1px solid #1C1C1C', py: 3 }}>
                                <Box display="flex" justifyContent="center" alignItems="center">
                                  <ThreeDots
                                    height="24"
                                    width="48"
                                    radius="6"
                                    color="#F79420"
                                    visible
                                    ariaLabel="loading-more"
                                  />
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                          {hasMoreUsers && (
                            <TableRow ref={loadMoreSentinelRef} sx={{ bgcolor: '#0F0F0F' }}>
                              <TableCell colSpan={22} sx={{ borderBottom: '1px solid #1C1C1C', py: 2, minHeight: 48 }} />
                            </TableRow>
                          )}
                        </>
                      ) : (
                        <>
                          {/* Invited Users only – no pagination */}
                          {(() => {
                            const allInvited = groupUsers.data?.invitedUsers ?? [];
                            const filteredInvited = searchName
                              ? allInvited.filter((each) => {
                                  const q = searchName.toLowerCase();
                                  return (
                                    each.name?.toLowerCase().includes(q) ||
                                    each.firstName?.toLowerCase().includes(q) ||
                                    each.lastName?.toLowerCase().includes(q) ||
                                    each.email?.toLowerCase().includes(q)
                                  );
                                })
                              : allInvited;

                            if (filteredInvited.length > 0) {
                              return filteredInvited.map((each) => (
                                <React.Fragment key={each.invitationId ?? each.userId ?? each.email}>
                                  <ProgramInvitedUsers
                                    data={each}
                                    showCompany={showCompany}
                                    showGoalProgress={showGoalProgress}
                                  />
                                </React.Fragment>
                              ));
                            }

                            return (
                              <TableRow>
                                <TableCell colSpan={22}>
                                  <Typography textAlign="center" color="#868686">
                                    {searchName ? 'Nobody invited matches your search' : 'Nobody is invited yet'}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            );
                          })()}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
          </Box>

        {/* Invite user dialog */}
        <InviteUserDialog
          handleClose={handleCloseUploadUsers}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          type="Add"
        />

        <ConfirmDialog
          open={lockedWarnOpen}
          title="This program is locked"
          message="Locked programs can’t take new people or audience. Would you like to unlock it and continue?"
          confirmLabel="Unlock & continue"
          busy={unlockBusy}
          busyLabel="Unlocking..."
          onConfirm={handleConfirmUnlock}
          onClose={() => (unlockBusy ? null : setLockedWarnOpen(false))}
        />

        {/*  Bulk upload members */}
        <Dialog
          open={openUploadUsers}
          onClose={handleCloseUploadUsers}
          scroll="body"
          fullWidth
          PaperProps={{ sx: { bgcolor: '#0F0F0F', color: '#FDFDFD', borderRadius: 2, border: '1px solid #444444' } }}
        >
          <CommonModalHeader
            title="Bulk upload people"
            handleCloseModal={handleCloseUploadUsers}
          />
          <DialogContent sx={{ color: 'white' }}>
            <Typography>
              In order to bulk upload people, please download the template file
              to proceed. <br /> First name, last name, email address, and role
              are required.
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              gap="8px"
              my={2}
            >
              <img
                src={downloadblue}
                alt="downloadblueimg"
                width="21"
                height="21"
                className="cursor-pointer"
                onClick={handleDownload}
              />
              <Typography
                className="cursor-pointer"
                variant="subtitle2"
                color="#0071A9"
                onClick={handleDownload}
              >
                Download bulk upload template
              </Typography>
            </Box>

            {/* Spreadsheet requirements */}
            <Box
              mb={2}
              p={1.5}
              borderRadius="8px"
              bgcolor="#0F1A1F"
              border="1px solid #1A4060"
            >
              <Typography variant="caption" color="#7DB8D4" fontWeight={600} display="block" mb={0.5}>
                Spreadsheet requirements
              </Typography>
              <Typography variant="caption" color="#868686" component="ul" sx={{ pl: 2, m: 0 }}>
                <li>File must be .xlsx format (max 50 KB)</li>
                <li>Required columns: First Name, Last Name, Email, Role</li>
                <li>Email addresses must be valid, with no extra spaces or special characters</li>
                <li>Do not include hyperlinks in any cell</li>
                <li>Role must be one of: mentor, mentee, admin</li>
              </Typography>
            </Box>

            <Box
              p={2.5}
              borderRadius="8px"
              bgcolor="black"
              border="1px solid #DEDFDF"
              className="cursor-pointer"
              onClick={handleButtonClick}
            >
              <Box textAlign="center">
                <IconButton>
                  <img src={upload} alt="upload" width="25" height="25" />
                </IconButton>
                <input
                  ref={fileInputRef}
                  type="file"
                  className="d-none"
                  placeholder="file"
                  accept=".xlsx"
                  onChange={handleBulkFileChanges}
                />
                <Box>
                  <p className="fs-12 secondary-light fw-600">
                    <span className="text-blue fs-14">Click to attach file</span>
                    <br /> Excel (.xlsx) only &nbsp;·&nbsp; max 50 KB
                  </p>
                  {bulkfileName ? (
                    <Typography
                      mt={1}
                      variant="h5"
                      style={{ color: 'green' }}
                    >
                      {bulkfileName}
                    </Typography>
                  ) : (
                    <FormHelperText
                      error
                      sx={{ textAlign: 'center' }}
                    >
                      {errorMessage}
                    </FormHelperText>
                  )}
                </Box>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
            <DosenButton
              // color="primary"
              // variant="contained"
              fullWidth
              onClick={handlebulkSubmit}
              loading={bulkUserLoading}
              loadingText="Adding..."
            >
              Add
            </DosenButton>
          </DialogActions>
        </Dialog>

        {/* Auto invite members */}
        <Dialog
          open={openAutoInvite}
          onClose={handleCloseAutoInvite}
          scroll="body"
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              width: 550,
              maxWidth: 550,
              bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
              color: '#FDFDFD',
              borderRadius: 2,
              outline: '1px solid var(--Stroke-Modal-border, rgba(255,255,255,0.1))'
            }
          }}
        >
          <CommonModalHeader
            title="Auto-enroll"
            handleCloseModal={handleCloseAutoInvite}
          />
          <DialogContent sx={{ px: 3, py: 2.5, bgcolor: 'transparent' }}>
            {showAutoInviteMenteesWarning && (
              <Box
                sx={{
                  p: 1.25,
                  borderRadius: 1,
                  background: 'rgba(245, 159, 0, 0.2)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  mb: 2.5
                }}
              >
                <WarningAmberOutlinedIcon sx={{ fontSize: 16, color: '#F5A623' }} />
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    lineHeight: '16px',
                    color: 'var(--Text-text-primary, #FFF)'
                  }}
                >
                  Auto-enroll enrolls {w('mentee', { plural: true, lower: true })} only. If you wish to enroll{' '}
                  {w('mentor', { plural: true, lower: true })}, you can use Manual Enroll or Bulk Enroll.
                </Typography>
              </Box>
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, width: '100%' }}>
                <Typography
                  sx={{
                    color: 'var(--Text-text-primary, #fdfdfd)',
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: 'Inter',
                    lineHeight: '20px'
                  }}
                >
                  Select the attributes to enroll:
                </Typography>
                <Box sx={{ position: 'relative', width: '100%' }}>
                  <Box
                    ref={autoInviteAnchorRef}
                    component="button"
                    type="button"
                    onClick={() =>
                      !autoInviteAll && !attributesLoading && setAutoInviteDropdownOpen((o) => !o)
                    }
                    disabled={autoInviteAll || attributesLoading}
                    sx={{
                      width: '100%',
                      pl: 2,
                      pr: 2,
                      py: 1,
                      minHeight: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      gap: 1,
                      flexWrap: 'wrap',
                      background: 'rgba(255,255,255,0.07)',
                      borderRadius: 1,
                      outline: '1px solid var(--Stroke-Form-Input-border-light, rgba(134,134,134,0.4))',
                      outlineOffset: -1,
                      border: 'none',
                      cursor: autoInviteAll || attributesLoading ? 'default' : 'pointer',
                      textAlign: 'left',
                      opacity: autoInviteAll || attributesLoading ? 0.7 : 1,
                      ...(!autoInviteAll &&
                        !attributesLoading && {
                          '&:hover': {
                            outline: '1px solid var(--Stroke-Border-border-highlight, rgba(255,255,255,0.35))'
                          }
                        }),
                      '&:focus': {
                        outline: '1px solid var(--Stroke-Border-border-highlight, rgba(255,255,255,0.35))'
                      }
                    }}
                  >
                    {attributesLoading ? (
                      <Typography
                        sx={{
                          color: 'var(--Text-text-tertiary, rgba(255,255,255,0.55))',
                          fontSize: 14,
                          fontFamily: 'Inter',
                          lineHeight: '20px'
                        }}
                      >
                        Loading attributes...
                      </Typography>
                    ) : autoInviteAttributes.length === 0 ? (
                      <Typography
                        sx={{
                          color: 'var(--Text-text-tertiary, rgba(255,255,255,0.55))',
                          fontSize: 14,
                          fontFamily: 'Inter',
                          lineHeight: '20px'
                        }}
                      >
                        Select attributes
                      </Typography>
                    ) : (
                      autoInviteAttributes.map((key) => {
                        const option = attributeOptions.find((o) => o.value === key);
                        const label = option?.label ?? key;
                        return (
                          <Chip
                            key={key}
                            label={label}
                            size="small"
                            onDelete={() =>
                              setAutoInviteAttributes((prev) => prev.filter((k) => k !== key))
                            }
                            deleteIcon={<CloseIcon sx={{ fontSize: 14 }} />}
                            sx={{
                              height: 22,
                              borderRadius: '20px',
                              background: 'transparent',
                              border: '1px solid var(--Stroke-Border-border, rgba(255,255,255,0.35))',
                              color: 'var(--Text-text-primary, #FFF)',
                              fontSize: 12,
                              fontFamily: 'Inter',
                              '& .MuiChip-label': { px: 1 },
                              '& .MuiChip-deleteIcon': {
                                background: 'none',
                                border: 'none',
                                color: 'var(--Text-text-primary, rgba(255,255,255,0.8))',
                                '&:hover': { color: '#FFF', background: 'none' }
                              }
                            }}
                          />
                        );
                      })
                    )}
                    {!attributesLoading && (
                      <Box
                        sx={{
                          width: 28,
                          minWidth: 28,
                          height: 24,
                          ml: 'auto',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}
                      >
                        <Box
                          sx={{
                            width: 12,
                            height: 6,
                            borderBottom: '2px solid var(--Stroke-icon-dim, rgba(134,134,134,0.8))',
                            borderRight: '2px solid var(--Stroke-icon-dim, rgba(134,134,134,0.8))',
                            transform: 'rotate(45deg)'
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                  <Popover
                    open={autoInviteDropdownOpen}
                    anchorEl={autoInviteAnchorRef.current}
                    onClose={() => setAutoInviteDropdownOpen(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{
                      sx: {
                        width: 500,
                        maxHeight: 384,
                        mt: 1,
                        padding: 0,
                        background: 'rgba(255,255,255,0.07)',
                        borderRadius: 1,
                        outline: '1px solid var(--Stroke-Border-border-highlight, rgba(255,255,255,0.35))',
                        boxShadow: 'none',
                        overflow: 'hidden'
                      }
                    }}
                  >
                    <Box sx={{ overflow: 'auto', maxHeight: 360 }}>
                      {attributeGroups.length === 0 && !attributesLoading && (
                        <Typography
                          sx={{
                            px: 2,
                            py: 3,
                            color: 'var(--Text-text-tertiary, rgba(255,255,255,0.55))',
                            fontSize: 13,
                            fontFamily: 'Inter',
                            textAlign: 'center',
                            lineHeight: '18px'
                          }}
                        >
                          No attributes configured for this organization. Please add attributes in Organization Settings first.
                        </Typography>
                      )}
                      {attributeGroups.map((group, gIdx) => (
                        <Box key={group._id ?? gIdx}>
                          <Box
                            sx={{
                              px: 2,
                              pt: '5px',
                              pb: 0.25,
                              color: 'var(--Text-text-tertiary, rgba(255,255,255,0.55))',
                              fontSize: 12,
                              fontFamily: 'Inter',
                              lineHeight: '16px'
                            }}
                          >
                            Attributes: {group.name}
                          </Box>
                          {(group.values || []).map((item, vIdx) => {
                            const key = `${group.name}||${item.value}`;
                            const selected = autoInviteAttributes.includes(key);
                            return (
                              <Box
                                key={item._id ?? vIdx}
                                component="button"
                                type="button"
                                onClick={() => {
                                  setAutoInviteAttributes((prev) =>
                                    selected ? prev.filter((k) => k !== key) : [...prev, key]
                                  );
                                }}
                                sx={{
                                  width: '100%',
                                  px: 2,
                                  py: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                  border: 'none',
                                  background: 'transparent',
                                  cursor: 'pointer',
                                  textAlign: 'left',
                                  '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' }
                                }}
                              >
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    p: '3px',
                                    flexShrink: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxSizing: 'border-box'
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 16,
                                      height: 16,
                                      borderRadius: '4px',
                                      bgcolor: 'var(--Fill-Transparent-trans-normal-9/90, rgba(255,255,255,0.09))',
                                      border: '1px solid',
                                      borderColor: selected
                                        ? 'var(--Stroke-Form-Input-border-highlight, rgba(255,255,255,0.9))'
                                        : 'var(--Stroke-Form-Input-border-light, rgba(134,134,134,0.4))',
                                      boxSizing: 'border-box',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {selected && (
                                      <CheckIcon
                                        sx={{
                                          fontSize: 12,
                                          color: 'var(--Stroke-Form-Input-border-highlight, #fff)'
                                        }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                                <Typography
                                  sx={{
                                    color: selected
                                      ? 'var(--Text-text-primary, #fdfdfd)'
                                      : 'var(--Text-text-secondary, rgba(255,255,255,0.85))',
                                    fontSize: 14,
                                    fontFamily: 'Inter',
                                    lineHeight: '20px'
                                  }}
                                >
                                  {item.value}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      ))}
                    </Box>
                  </Popover>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" gap={1.5}>
                <Checkbox
                  checked={autoInviteAll}
                  onChange={(event) => {
                    const {checked} = event.target;
                    setAutoInviteAll(checked);
                    if (checked) setAutoInviteAttributes([]);
                  }}
                  sx={{
                    color: 'rgba(255,255,255,0.4)',
                    '&.Mui-checked': {
                      color: '#F5A623'
                    }
                  }}
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    fontFamily: 'Inter',
                    color: 'var(--Text-text-secondary, rgba(255,255,255,0.7))'
                  }}
                >
                  Enroll everyone
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: 14,
                  fontFamily: 'Inter',
                  color: 'var(--Text-text-secondary, rgba(255,255,255,0.7))'
                }}
              >
                If you would like to add new attributes, contact your Org Admin
                from the primary People page.
              </Typography>

              <Box sx={{ alignSelf: 'center' }}>
                <DosenButton
                  sizeVariant="sm"
                  tone="cta"
                  disabled={autoInviteLoading}
                  loading={autoInviteLoading}
                  loadingText="Enrolling..."
                  onClick={handleAutoInviteSubmit}
                >
                  Auto-Enroll
                </DosenButton>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        <LevelQuestionAnswers
          open={viewAnswerOpen}
          setOpen={setViewAnswerOpen}
          taskLoading={taskLoading}
          tasksData={tasksData}
        />
    </Box>
  );
};

export default ProgramUsers;
